import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { cn } from '@/lib/utils';
import type { WorkingTimeModel } from '../../data/databaseSchema';

const DAYS = ['MO', 'DI', 'MI', 'DO', 'FR', 'SA', 'SO'] as const;

interface WorkingHoursTableProps {
  model: WorkingTimeModel;
  className?: string;
}

export function WorkingHoursTable({ model, className }: WorkingHoursTableProps) {
  const hours = [
    model.monday,
    model.tuesday,
    model.wednesday,
    model.thursday,
    model.friday,
    model.saturday,
    model.sunday,
  ];

  return (
    <div className="w-fit border border-border-defaul rounded-xs [&_[data-slot=table-container]]:w-fit">
      <Table className={cn('w-min table-fixed text-xs leading-none', className)}>
        <TableHeader>
          <TableRow className="h-4 bg-accent/50 border-0 hover:bg-transparent">
            {DAYS.map((day) => (
              <TableHead
                key={day}
                className="h-4 w-4.5 px-0 py-0 text-center font-normal leading-none"
              >
                {day}
              </TableHead>
            ))}
          </TableRow>
        </TableHeader>
        <TableBody>
          <TableRow className="h-4 border-0 hover:bg-transparent">
            {hours.map((h, day) => (
              <TableCell
                key={DAYS[day]}
                className="h-4 w-4.5 px-0 py-0 text-center leading-none tabular-nums"
              >
                {h ?? '-'}
              </TableCell>
            ))}
          </TableRow>
        </TableBody>
      </Table>
    </div>
  );
}
